import { API } from "../config/api"

const TOKEN_KEY = "invi_token"

function authHeaders(): HeadersInit {
  const token = localStorage.getItem(TOKEN_KEY)
  return {
    "Content-Type": "application/json",
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  }
}

async function handleResponse<T>(resp: Response): Promise<T> {
  if (!resp.ok) {
    const body = await resp.json().catch(() => ({}))
    throw new Error(body.detail || `Request failed (HTTP ${resp.status})`)
  }
  return resp.json()
}

export async function updateEmail(
  currentPassword: string,
  newEmail: string
): Promise<void> {
  const resp = await fetch(`${API.baseUrl}${API.endpoints.changeEmail}`, {
    method: "PATCH",
    headers: authHeaders(),
    body: JSON.stringify({
      current_password: currentPassword,
      new_email: newEmail,
    }),
  })
  await handleResponse(resp)
}

// Changing the password retires every login made with the old one; the response
// carries a fresh login for this browser (null from a backend that predates that).
export async function updatePassword(
  currentPassword: string,
  newPassword: string
): Promise<string | null> {
  const resp = await fetch(`${API.baseUrl}${API.endpoints.changePassword}`, {
    method: "PATCH",
    headers: authHeaders(),
    body: JSON.stringify({
      current_password: currentPassword,
      new_password: newPassword,
    }),
  })
  const body = await handleResponse<{ access_token?: string }>(resp)
  return typeof body.access_token === "string" ? body.access_token : null
}

export async function updateUsername(
  currentPassword: string,
  newUsername: string
): Promise<void> {
  const resp = await fetch(`${API.baseUrl}${API.endpoints.changeUsername}`, {
    method: "PATCH",
    headers: authHeaders(),
    body: JSON.stringify({
      current_password: currentPassword,
      new_username: newUsername,
    }),
  })
  await handleResponse(resp)
}
